import { NotificationManager } from "react-notifications";


import apiURL from"./apiURL";
import { v4 as uuidv4 } from 'uuid';
const Types = {
  GROUP_SAVING: "GROUP_SAVING",
  GROUP_SAVE_CURRENT: "GROUP_SAVE_CURRENT",
  GROUP_OPEN_MODAL: "GROUP_OPEN_MODAL",
  GROUP_DELETE_MODAL: "GROUP_DELETE_MODAL",
  GROUP_DELETING: "GROUP_DELETING",
  GROUP_DELETED: "GROUP_DELETED",
  GROUP_CONFIRM_CHANGE_MODAL: "GROUP_CONFIRM_CHANGE_MODAL",
  GROUP_UPDATING: "GROUP_UPDATING",
  GROUP_UPDATE: "GROUP_UPDATE",
};

const groupSetSaving = (id) => ({
  type: Types.GROUP_SAVING,
  id,
});

const groupUpdateSaveStatus = (response, group) => ({
  type: Types.GROUP_SAVE_CURRENT,
  payload: response,
  group,
});

const saveGroup = (group) => {
  return (dispatch, getState) => {

    dispatch(groupSetSaving(true));

    fetch(apiURL + '/settings/pension/group', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(group),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(groupUpdateSaveStatus(data, group));
        dispatch(getGroups())
        dispatch(setOpenModal(false))
        NotificationManager.success('Successfully Saved Group', 'Save Group')
      })
      .catch((error) => {
        console.error(error)
        NotificationManager.error('Error Saving Group', 'Save Group')
      })
  };
};

const setOpenModal = (status, group) => ({
  type: Types.GROUP_OPEN_MODAL,
  status: status,
  group,
});

const deleteGroupModal = (status, group) => ({
  type: Types.GROUP_DELETE_MODAL,
  status,
  group,
});

const deletingGroup = () => ({
  type: Types.GROUP_DELETING
});

const deletedGroup = () => ({
  type: Types.GROUP_DELETED,
});

const deleteGroup = (group) => {
  return (dispatch, getState) => {

    dispatch(deletingGroup())

    fetch(apiURL + `/settings/pension/group/delete`, {
      credentials: 'include',
      method: 'DELETE',
      body: JSON.stringify({ id: group }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(() => {
        dispatch(deletedGroup())
        dispatch(deleteGroupModal(false))
        dispatch(getGroups())
        NotificationManager.success('Group Successfully Deleted!', 'Delete Group')
      })
      .catch((error) => {
        console.error(error)
        NotificationManager.error('Error Deleting Group', 'Delete Group')
      })
  }
}

const confirmModal = ({ input, status, formType }) => ({
  type: Types.GROUP_CONFIRM_CHANGE_MODAL,
  input,
  status,
  formType,
});

const groupUpdating = (options) => ({
  type: Types.GROUP_UPDATING,
  options
});

const updateGroups = (data) => ({
  type: Types.GROUP_UPDATE,
  data
});

const getGroups = (options) => {
  const qs = new URLSearchParams(options).toString();
  return (dispatch, getState) => {
    dispatch(groupUpdating(options));
      fetch(apiURL + `/settings/pension/group?${qs}`, {
          credentials: 'include',
          method: 'GET',
          headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
          }
      }).then(response => response.json()).then(data => dispatch(updateGroups(data?.groups)));
  }
};

const Actions = {
  saveGroup,
  setOpenModal,
  deleteGroupModal,
  deleteGroup,
  confirmModal,
  updateGroups,
  getGroups,
};

export { Types, Actions };
